import APPCONFIG from '../../constants/Config';
import {
  REINIT_STATE,
  UPDATE_DEVICE_CONFIG,
  UPDATE_DEVICE_CONFIG_SUCCESS,
  UPDATE_DEVICE_CONFIG_ERROR,
} from '../../constants/ActionTypes';

const initialSettings = APPCONFIG.deviceConfig;
const deviceConfig = (state = initialSettings, action) => {
  let key;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullDevice' || action.target === 'currentDevice') {
        return {
          ...state,
          update: { ...initialSettings.update },
        };
      }
      switch (action.target) {
        case 'updateDeviceConfig':
          key = 'update';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // UPDATE
    case UPDATE_DEVICE_CONFIG:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          idDevice: action.id,
          idConfig: action.idConfig,
          error: null,
        },
      };
    case UPDATE_DEVICE_CONFIG_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case UPDATE_DEVICE_CONFIG_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
          asyncOperation: action.data.data,
        },
      };
    default:
      return state;
  }
};

export default deviceConfig;



// WEBPACK FOOTER //
// ./reducers/device/deviceConfig.js